import React, { useMemo } from 'react'

import { ABSOLUTE_MIN_CARD_PX, MIN_CARD_MINUTES } from '../../constants'
import { BerthCard } from '../../types'
import { calcOverlapLayout } from '../../utils/overlapLayout'
import { minutesToPx, timeToMinutes } from '../../utils/timeConvert'
import { BerthCardComponent } from '../BerthCard'

type Props = {
  cards: BerthCard[]
  onCardTap: (cardId: string) => void
  pxPerMinute: number
}

export const CardLayer: React.FC<Props> = ({ cards, onCardTap, pxPerMinute }) => {
  const cardsWithMinutes = useMemo(
    () =>
      cards.map((c) => ({
        ...c,
        startMin: timeToMinutes(c.startTime),
        endMin: timeToMinutes(c.endTime),
        displayStartMin: timeToMinutes(c.originalStartTime ?? c.startTime),
        displayEndMin: timeToMinutes(c.originalEndTime ?? c.endTime),
      })),
    [cards]
  )

  // 視覚的な最小高さ（15分）を考慮した endMin で重なり判定
  const cardsWithVisualEnd = useMemo(
    () =>
      cardsWithMinutes.map((c) => ({
        ...c,
        endMin: Math.max(c.endMin, c.startMin + MIN_CARD_MINUTES),
      })),
    [cardsWithMinutes]
  )

  const overlapLayout = useMemo(() => calcOverlapLayout(cardsWithVisualEnd), [cardsWithVisualEnd])
  const minCardPx = Math.max(ABSOLUTE_MIN_CARD_PX, minutesToPx(MIN_CARD_MINUTES, pxPerMinute))
  return (
    <>
      {cardsWithMinutes.map((card) => {
        const overlap = overlapLayout[card.id] || { leftPercent: 0, widthPercent: 100 }
        const layout = {
          top: minutesToPx(card.startTime ? Number(card.startMin) : 0, pxPerMinute),
          height: Math.max(
            minCardPx,
            minutesToPx(
              card.endTime && card.startTime ? Number(card.endMin - card.startMin) : 0,
              pxPerMinute
            )
          ),
          left: overlap.leftPercent,
          width: overlap.widthPercent,
        }
        return <BerthCardComponent key={card.id} card={card} layout={layout} onTap={onCardTap} />
      })}
    </>
  )
}
